<template>
  <v-data-table
    :headers="getDebitNotesTableHeaders"
    :items="getDebitNotesList"
    :total-items="totalItems"
    :loading="loading"
    :pagination="paginationData"
    :rows-per-page-items="[5, 10, 25, 50, 100]"
    @update:pagination="onPaginationUpdate"
    sort-icon="fa-arrow-down"
    class="elevation-1 main-table"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.number }}</td>
      <td>{{ props.item.recipient_display || '—' }}</td>
      <td>{{ props.item.recipient_nip || '—' }}</td>
      <td>{{ props.item.issued_at || '—' }}</td>
      <td>{{ props.item.due_date || '—' }}</td>
      <td>PLN {{ props.item.total_amount }}</td>
      <td>{{ props.item.payment_method_label || props.item.payment_method }}</td>
      <td>
        <v-menu offset-y :close-on-content-click="false"
                v-if="props.item.voucher_numbers && props.item.voucher_numbers.length">
          <span slot="activator" class="voucher-count-badge">
            {{ props.item.voucher_count }}
            <v-icon size="12px" class="ml-1 mr-0">fas fa-caret-down</v-icon>
          </span>
          <v-card class="pa-2">
            <div class="grey--text caption mb-2">Vouchery w nocie</div>
            <div class="voucher-chip-list">
              <v-chip v-for="num in props.item.voucher_numbers" :key="num"
                      small color="#555474" text-color="white" class="ma-1">
                {{ num }}
              </v-chip>
            </div>
          </v-card>
        </v-menu>
        <span v-else>{{ props.item.voucher_count != null ? props.item.voucher_count : '—' }}</span>
      </td>
      <td class="text-xs-center">
        <v-btn small color="#555474"
               @click="$router.push({ name: 'DebitNoteDetails', params: { noteId: props.item.id } })"
               dark>
          Zobacz
        </v-btn>
        <v-menu bottom offset-y>
          <v-btn small slot="activator">
            Więcej
            <v-icon size="15px" class="ml-2 mr-0">fas fa-caret-down</v-icon>
          </v-btn>
          <v-list class="v-list--button-list">
            <v-list-tile @click="$router.push({ name: 'EditDebitNote', params: { noteId: props.item.id } })">
              <v-list-tile-title>Edytuj</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('printPDF', props.item.id)">
              <v-list-tile-title>Drukuj PDF</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('downloadPDF', props.item.id, props.item.number)">
              <v-list-tile-title>Pobierz PDF</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-permissions
                         @click="$emit('deleteNote', props.item.id)"
                         class="v-menu--v-list-title-delete">
              <v-list-tile-title>Usuń</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </template>
  </v-data-table>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'DebitNoteTable',
    props: {
      loading: Boolean,
      totalItems: { type: Number, default: 0 },
      currentPage: { type: Number, default: 1 },
    },
    data() {
      return {
        initialized: false,
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 25,
        },
      };
    },
    mounted() {
      this.$nextTick(() => { this.initialized = true; });
    },
    watch: {
      currentPage(val) {
        this.paginationData = Object.assign({}, this.paginationData, { page: val });
      },
    },
    computed: {
      ...mapGetters('DebitNoteStore', ['getDebitNotesList', 'getDebitNotesTableHeaders']),
    },
    methods: {
      onPaginationUpdate(pagination) {
        this.paginationData = pagination;
        if (this.initialized) {
          this.$emit('paginationChange', pagination);
        }
      },
    },
  };
</script>

<style scoped>
  .voucher-count-badge {
    cursor: pointer;
    font-weight: 600;
    color: #555474;
    white-space: nowrap;
  }

  .voucher-chip-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: 260px;
    overflow-y: auto;
  }
</style>
